import Immutable, { Immutable as ImmutableGenericType } from 'seamless-immutable'
import { AccountNumber } from 'app-types'

export interface Payment {
  amount?: number
  currentAccountNumber?: AccountNumber
  dueDate?: number // fix to ISO 8601
  originalAccountNumber?: AccountNumber
  qrCode?: string
  transactionNote?: string
}

export type PaymentState = ImmutableGenericType<Payment>

export const initialState: PaymentState = Immutable({
  amount: undefined,
  currentAccountNumber: undefined,
  dueDate: undefined,
  originalAccountNumber: undefined,
  qrCode: undefined,
  transactionNote: undefined,
})
